import { ChatCreateGroup } from './ChatCreateGroup'
import { ChatCreateGroupContextProvider } from './ChatCreateGroup/ChatCreateGroupContext'

export const CreateGroupChatWrapper = () => (
  <ChatCreateGroupContextProvider initialState={{ variant: 'create' }}>
    <ChatCreateGroup />
  </ChatCreateGroupContextProvider>
)
